const actions = {
  SET_STATE: "setting/SET_STATE",
  HEALTH_CHECK: "health/HEALTH_CHECK",
};

export default actions;
